if (typeof window.DialogDrawer !== 'function') {
  window.DialogDrawer = class DialogDrawer {
    constructor(root = document) {
      this.root = root;
      this.activeTrigger = null;
      this.boundDialogs = new WeakSet();
      this.animationFallback = 320;
      this.init();
    }

    init() {
      this.root.querySelectorAll('[data-dialog-trigger]').forEach((trigger) => {
        if (trigger.dataset.dialogBound === 'true') {
          return;
        }

        trigger.dataset.dialogBound = 'true';
        trigger.addEventListener('click', () => this.open(trigger));
      });
    }

    open(trigger) {
      const targetId = trigger.getAttribute('data-dialog-target');
      const dialog = targetId ? document.getElementById(targetId) : null;

      if (!dialog) {
        return;
      }

      this.activeTrigger = trigger;
      this.bindDialog(dialog);
      window.clearTimeout(dialog.drawerCloseTimer);
      window.clearTimeout(dialog.drawerOpenTimer);
      dialog.classList.remove('drawer-dialog--open', 'drawer-dialog--closing');
      dialog.dataset.dialogClosing = 'false';
      const drawerPanel = dialog.querySelector('.drawer-dialog__inner');

      if (!dialog.open) {
        if (typeof dialog.showModal === 'function') {
          try {
            dialog.showModal();
          } catch (error) {
            dialog.setAttribute('open', '');
          }
        } else {
          dialog.setAttribute('open', '');
        }
      }
      document.body.classList.add('drawer-dialog-open');

      if (drawerPanel) {
        drawerPanel.setAttribute('tabindex', '-1');
        drawerPanel.focus({ preventScroll: true });
        drawerPanel.getBoundingClientRect();
      }
      window.requestAnimationFrame(() => {
        dialog.drawerOpenTimer = window.setTimeout(() => {
          if (dialog.open && dialog.dataset.dialogClosing !== 'true') {
            drawerPanel?.getBoundingClientRect();
            dialog.classList.add('drawer-dialog--open');
          }
        }, 24);
      });

    }

    close(dialog) {
      if (!dialog.open || dialog.dataset.dialogClosing === 'true') {
        return;
      }

      dialog.dataset.dialogClosing = 'true';
      window.clearTimeout(dialog.drawerOpenTimer);
      dialog.classList.remove('drawer-dialog--open');
      dialog.classList.add('drawer-dialog--closing');

      this.afterDrawerTransition(dialog, () => {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          dialog.dispatchEvent(new Event('close'));
        }
      });
    }

    afterDrawerTransition(dialog, callback) {
      const inner = dialog.querySelector('.drawer-dialog__inner');
      if (!inner || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        callback();
        return;
      }

      let finished = false;
      const finish = () => {
        if (finished) {
          return;
        }

        finished = true;
        window.clearTimeout(dialog.drawerCloseTimer);
        inner.removeEventListener('transitionend', onTransitionEnd);
        callback();
      };

      const onTransitionEnd = (event) => {
        if (event.target === inner && event.propertyName === 'transform') {
          finish();
        }
      };

      inner.addEventListener('transitionend', onTransitionEnd);
      dialog.drawerCloseTimer = window.setTimeout(finish, this.animationFallback);
    }

    bindDialog(dialog) {
      if (this.boundDialogs.has(dialog)) {
        return;
      }

      this.boundDialogs.add(dialog);

      dialog.querySelectorAll('[data-dialog-close]').forEach((button) => {
        button.addEventListener('click', () => this.close(dialog));
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close(dialog);
      });

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close(dialog);
        }
      });

      dialog.addEventListener('close', () => {
        window.clearTimeout(dialog.drawerOpenTimer);
        window.clearTimeout(dialog.drawerCloseTimer);
        dialog.classList.remove('drawer-dialog--open', 'drawer-dialog--closing');
        dialog.dataset.dialogClosing = 'false';
        if (!document.querySelector('.drawer-dialog[open]')) {
          document.body.classList.remove('drawer-dialog-open');
        }
        if (this.activeTrigger) {
          this.activeTrigger.focus({ preventScroll: true });
          this.activeTrigger = null;
        }
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          this.close(dialog);
        }
      });
    }
  };
}

document.addEventListener('DOMContentLoaded', () => {
  new window.DialogDrawer();
});
